// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  max-width: 800px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  background-color: #f8f9fa;
  border-radius: 8px 8px 0 0;
}

.modal-header h2 {
  margin: 0;
  color: #333;
  font-size: 1.5rem;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.close-button:hover {
  background-color: #e9ecef;
  color: #333;
}

.modal-body {
  padding: 20px;
}

.session-summary {
  margin-bottom: 30px;
}

.session-summary h3 {
  color: #333;
  margin-bottom: 15px;
  font-size: 1.2rem;
}

.summary-grid {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 20px;
}

.summary-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}

.summary-item {
  background-color: #f8f9fa;
  padding: 12px;
  border-radius: 6px;
  border-left: 4px solid #007bff;
}

.summary-item strong {
  color: #495057;
}

.documents-section {
  margin-bottom: 30px;
}

.documents-section h3 {
  color: #333;
  margin-bottom: 15px;
  font-size: 1.2rem;
  border-bottom: 2px solid #007bff;
  padding-bottom: 5px;
}

.documents-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.document-item {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.document-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.doc-loader {
  display: flex;
  align-items: center;
  gap: 8px;
}

.doc-spinner {
  width: 20px;
  height: 20px;
  border: 3px solid #2a03b7;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.doc-error-container {
  display: flex;
  align-items: center;
  gap: 12px;
}

.doc-error {
  color: red;
}

.doc-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: inherit;
  cursor: pointer;
  font-weight: 500;
  font-size: 12px;
  padding: 8px 20px;
  color: white;
  background: #ad5389;
  background: linear-gradient(0deg,
      rgba(77, 54, 208, 1) 0%,
      rgba(132, 116, 254, 1) 100%);
  border: none;
  box-shadow: 0 0.7em 1.5em -0.5em #4d36d0be;
  letter-spacing: 0.05em;
  border-radius: 20em;
  text-decoration: none;
}

.doc-btn svg {
  margin-right: 8px;
}

.doc-btn:hover {
  box-shadow: 0 0.5em 1.5em -0.5em #4d36d0be;
}

.doc-btn:active {
  box-shadow: 0 0.3em 1em -0.5em #4d36d0be;
}


.document-item h4 {
  margin: 0 0 10px 0;
  color: #007bff;
  font-size: 1.1rem;
}

.document-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.document-details-header {
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
}

.document-details p {
  margin: 5px 0;
  font-size: 0.9rem;
}

.document-details strong {
  color: #495057;
}

.document-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.document-options button {
  padding: 5px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  gap: 8px;
  background-color: rgb(218, 218, 223);
  color: black;
  border-radius: 20px;
  border: none;
  cursor: pointer;
}

.document-options button:hover {
  background-color: rgb(212, 201, 201);
}

.options {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #dee2e6;
}

.options p {
  margin-bottom: 8px;
  font-weight: bold;
  color: #495057;
}

.options ul {
  margin: 0;
  padding-left: 20px;
  list-style-type: disc;
}

.options li {
  margin: 3px 0;
  font-size: 0.85rem;
  color: #666;
}

@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    margin: 10px;
  }

  .summary-grid {
    grid-template-columns: 1fr;
  }

  .document-details {
    grid-template-columns: 1fr;
  }

  .document-details-header {
    gap: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Start/SessionDetailsModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB;;kCAEgC;EAChC,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;AAC1C;;;AAGA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,QAAQ;EACR,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 8px;\n  max-width: 800px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #eee;\n  background-color: #f8f9fa;\n  border-radius: 8px 8px 0 0;\n}\n\n.modal-header h2 {\n  margin: 0;\n  color: #333;\n  font-size: 1.5rem;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n}\n\n.close-button:hover {\n  background-color: #e9ecef;\n  color: #333;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.session-summary {\n  margin-bottom: 30px;\n}\n\n.session-summary h3 {\n  color: #333;\n  margin-bottom: 15px;\n  font-size: 1.2rem;\n}\n\n.summary-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n.summary-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 15px;\n}\n\n.summary-item {\n  background-color: #f8f9fa;\n  padding: 12px;\n  border-radius: 6px;\n  border-left: 4px solid #007bff;\n}\n\n.summary-item strong {\n  color: #495057;\n}\n\n.documents-section {\n  margin-bottom: 30px;\n}\n\n.documents-section h3 {\n  color: #333;\n  margin-bottom: 15px;\n  font-size: 1.2rem;\n  border-bottom: 2px solid #007bff;\n  padding-bottom: 5px;\n}\n\n.documents-list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.document-item {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 15px;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.document-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.doc-loader {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.doc-spinner {\n  width: 20px;\n  height: 20px;\n  border: 3px solid #2a03b7;\n  border-bottom-color: transparent;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n}\n\n@keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.doc-error-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.doc-error {\n  color: red;\n}\n\n.doc-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-family: inherit;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 12px;\n  padding: 8px 20px;\n  color: white;\n  background: #ad5389;\n  background: linear-gradient(0deg,\n      rgba(77, 54, 208, 1) 0%,\n      rgba(132, 116, 254, 1) 100%);\n  border: none;\n  box-shadow: 0 0.7em 1.5em -0.5em #4d36d0be;\n  letter-spacing: 0.05em;\n  border-radius: 20em;\n  text-decoration: none;\n}\n\n.doc-btn svg {\n  margin-right: 8px;\n}\n\n.doc-btn:hover {\n  box-shadow: 0 0.5em 1.5em -0.5em #4d36d0be;\n}\n\n.doc-btn:active {\n  box-shadow: 0 0.3em 1em -0.5em #4d36d0be;\n}\n\n\n.document-item h4 {\n  margin: 0 0 10px 0;\n  color: #007bff;\n  font-size: 1.1rem;\n}\n\n.document-details {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.document-details-header {\n  display: flex;\n  gap: 40px;\n  flex-wrap: wrap;\n}\n\n.document-details p {\n  margin: 5px 0;\n  font-size: 0.9rem;\n}\n\n.document-details strong {\n  color: #495057;\n}\n\n.document-options {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.document-options button {\n  padding: 5px 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  gap: 8px;\n  background-color: rgb(218, 218, 223);\n  color: black;\n  border-radius: 20px;\n  border: none;\n  cursor: pointer;\n}\n\n.document-options button:hover {\n  background-color: rgb(212, 201, 201);\n}\n\n.options {\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #dee2e6;\n}\n\n.options p {\n  margin-bottom: 8px;\n  font-weight: bold;\n  color: #495057;\n}\n\n.options ul {\n  margin: 0;\n  padding-left: 20px;\n  list-style-type: disc;\n}\n\n.options li {\n  margin: 3px 0;\n  font-size: 0.85rem;\n  color: #666;\n}\n\n@media (max-width: 768px) {\n  .modal-content {\n    width: 95%;\n    margin: 10px;\n  }\n\n  .summary-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .document-details {\n    grid-template-columns: 1fr;\n  }\n\n  .document-details-header {\n    gap: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
